module.exports = __webpack_public_path__ + "img/19.1cb2f2ab.png";